import { Component, OnInit } from '@angular/core';
import {Language} from '../../../models/disclaimer/language.model';
import {HttpService} from '../../../services/http.service';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';

@Component({
  selector: 'app-help-config',
  templateUrl: './help-config.component.html',
  styleUrls: ['./help-config.component.scss']
})
export class HelpConfigComponent implements OnInit {

  englishText1: Language = new Language();
  germanText1: Language = new Language();
  frenchText1: Language = new Language();
  dutchText1: Language = new Language();
  englishHeader1: Language = new Language();
  germanHeader1: Language = new Language();
  frenchHeader1: Language = new Language();
  dutchHeader1: Language = new Language();

  englishText2: Language = new Language();
  germanText2: Language = new Language();
  frenchText2: Language = new Language();
  dutchText2: Language = new Language();
  englishHeader2: Language = new Language();
  germanHeader2: Language = new Language();
  frenchHeader2: Language = new Language();
  dutchHeader2: Language = new Language();

  englishText3: Language = new Language();
  germanText3: Language = new Language();
  frenchText3: Language = new Language();
  dutchText3: Language = new Language();
  englishHeader3: Language = new Language();
  germanHeader3: Language = new Language();
  frenchHeader3: Language = new Language();
  dutchHeader3: Language = new Language();

  englishText4: Language = new Language();
  germanText4: Language = new Language();
  frenchText4: Language = new Language();
  dutchText4: Language = new Language();
  englishHeader4: Language = new Language();
  germanHeader4: Language = new Language();
  frenchHeader4: Language = new Language();
  dutchHeader4: Language = new Language();

  englishText5: Language = new Language();
  germanText5: Language = new Language();
  frenchText5: Language = new Language();
  dutchText5: Language = new Language();
  englishHeader5: Language = new Language();
  germanHeader5: Language = new Language();
  frenchHeader5: Language = new Language();
  dutchHeader5: Language = new Language();

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.http.fetchHelpContent().subscribe((res) => {
      this.englishHeader1 = res.find(r => r.lang === 'en' && r.item === 'help-header-1');
      this.germanHeader1 = res.find(r => r.lang === 'de' && r.item === 'help-header-1');
      this.frenchHeader1 = res.find(r => r.lang === 'fr' && r.item === 'help-header-1');
      this.dutchHeader1 = res.find(r => r.lang === 'nl' && r.item === 'help-header-1');
      this.englishText1 = res.find(r => r.lang === 'en' && r.item === 'help-text-1');
      this.germanText1 = res.find(r => r.lang === 'de' && r.item === 'help-text-1');
      this.frenchText1 = res.find(r => r.lang === 'fr' && r.item === 'help-text-1');
      this.dutchText1 = res.find(r => r.lang === 'nl' && r.item === 'help-text-1');

      this.englishHeader2 = res.find(r => r.lang === 'en' && r.item === 'help-header-2');
      this.germanHeader2 = res.find(r => r.lang === 'de' && r.item === 'help-header-2');
      this.frenchHeader2 = res.find(r => r.lang === 'fr' && r.item === 'help-header-2');
      this.dutchHeader2 = res.find(r => r.lang === 'nl' && r.item === 'help-header-2');
      this.englishText2 = res.find(r => r.lang === 'en' && r.item === 'help-text-2');
      this.germanText2 = res.find(r => r.lang === 'de' && r.item === 'help-text-2');
      this.frenchText2 = res.find(r => r.lang === 'fr' && r.item === 'help-text-2');
      this.dutchText2 = res.find(r => r.lang === 'nl' && r.item === 'help-text-2');

      this.englishHeader3 = res.find(r => r.lang === 'en' && r.item === 'help-header-3');
      this.germanHeader3 = res.find(r => r.lang === 'de' && r.item === 'help-header-3');
      this.frenchHeader3 = res.find(r => r.lang === 'fr' && r.item === 'help-header-3');
      this.dutchHeader3 = res.find(r => r.lang === 'nl' && r.item === 'help-header-3');
      this.englishText3 = res.find(r => r.lang === 'en' && r.item === 'help-text-3');
      this.germanText3 = res.find(r => r.lang === 'de' && r.item === 'help-text-3');
      this.frenchText3 = res.find(r => r.lang === 'fr' && r.item === 'help-text-3');
      this.dutchText3 = res.find(r => r.lang === 'nl' && r.item === 'help-text-3');

      this.englishHeader4 = res.find(r => r.lang === 'en' && r.item === 'help-header-4');
      this.germanHeader4 = res.find(r => r.lang === 'de' && r.item === 'help-header-4');
      this.frenchHeader4 = res.find(r => r.lang === 'fr' && r.item === 'help-header-4');
      this.dutchHeader4 = res.find(r => r.lang === 'nl' && r.item === 'help-header-4');
      this.englishText4 = res.find(r => r.lang === 'en' && r.item === 'help-text-4');
      this.germanText4 = res.find(r => r.lang === 'de' && r.item === 'help-text-4');
      this.frenchText4 = res.find(r => r.lang === 'fr' && r.item === 'help-text-4');
      this.dutchText4 = res.find(r => r.lang === 'nl' && r.item === 'help-text-4');

      this.englishHeader5 = res.find(r => r.lang === 'en' && r.item === 'help-header-5');
      this.germanHeader5 = res.find(r => r.lang === 'de' && r.item === 'help-header-5');
      this.frenchHeader5 = res.find(r => r.lang === 'fr' && r.item === 'help-header-5');
      this.dutchHeader5 = res.find(r => r.lang === 'nl' && r.item === 'help-header-5');
      this.englishText5 = res.find(r => r.lang === 'en' && r.item === 'help-text-5');
      this.germanText5 = res.find(r => r.lang === 'de' && r.item === 'help-text-5');
      this.frenchText5 = res.find(r => r.lang === 'fr' && r.item === 'help-text-5');
      this.dutchText5 = res.find(r => r.lang === 'nl' && r.item === 'help-text-5');
      });
  }

  updateHelps() {
    let data: Language[] = [];
    data.push(this.englishText1);
    data.push(this.germanText1);
    data.push(this.frenchText1);
    data.push(this.dutchText1);
    data.push(this.englishHeader1);
    data.push(this.germanHeader1);
    data.push(this.frenchHeader1);
    data.push(this.dutchHeader1);
    data.push(this.englishText2);
    data.push(this.germanText2);
    data.push(this.frenchText2);
    data.push(this.dutchText2);
    data.push(this.englishHeader2);
    data.push(this.germanHeader2);
    data.push(this.frenchHeader2);
    data.push(this.dutchHeader2);
    data.push(this.englishText3);
    data.push(this.germanText3);
    data.push(this.frenchText3);
    data.push(this.dutchText3);
    data.push(this.englishHeader3);
    data.push(this.germanHeader3);
    data.push(this.frenchHeader3);
    data.push(this.dutchHeader3);
    data.push(this.englishText4);
    data.push(this.germanText4);
    data.push(this.frenchText4);
    data.push(this.dutchText4);
    data.push(this.englishHeader4);
    data.push(this.germanHeader4);
    data.push(this.frenchHeader4);
    data.push(this.dutchHeader4);
    data.push(this.englishText5);
    data.push(this.germanText5);
    data.push(this.frenchText5);
    data.push(this.dutchText5);
    data.push(this.englishHeader5);
    data.push(this.germanHeader5);
    data.push(this.frenchHeader5);
    data.push(this.dutchHeader5);

    this.http.saveHelpContent(data).subscribe(() => {
      SweetUtil.showSuccess('Saved').then();

    });
  }

}
